<template>
      <div class="underLogoPhrase">
        <h2 class="font-weight-bold mb-4 centers">Qui sommes-nous</h2>
    </div>
  <div class="container">


    <section>
      <h3>Notre combat : sauver des vies</h3>
      <p>Lutter contre la maltraitance animale, c’est refuser la violence et l’indifférence. 
      C’est dire non à la souffrance infligée à des êtres vivants et sensibles qui ne peuvent pas se défendre. 
      C’est se battre pour que chaque animal soit reconnu dans son intégrité, sa dignité et son individualité.</p>
    </section>

    <section>
      <h3>14 ans de sauvetages et de renaissances</h3>
      <p>Depuis plus de 14 ans, <span class="highlight">A.J.P.L.A.</span> offre une vie meilleure à des animaux en détresse ou victimes de maltraitance.</p>
      <p>Avant leur prise en charge, beaucoup vivaient dans des conditions indignes : lieux insalubres, garages, cages, coffres de voiture, balcons, environnements souillés…</p>
      <p>Nombre d’entre eux étaient malades, sous-alimentés, blessés, terrorisés, battus, attachés ou enfermés. Cette souffrance est intolérable. Notre engagement est total.</p>
      <p>Grâce à l’aide de comportementalistes, d’éducateurs et de familles d’accueil, nos protégés réapprennent peu à peu à aimer, à jouer, à vivre. Et lorsqu’un animal traumatisé se blottit pour la première fois contre nous, nous comprenons pleinement pourquoi nous nous battons : derrière chaque regard confiant, il y a une renaissance.</p>
      <p>Toutes les personnes de notre équipe sont bénévoles.</p>
    </section>

    <section>
      <h3>Nos missions</h3>
      <p><span class="highlight">Agir pour une justice plus juste :</span> Nous demandons aux autorités l’application stricte des lois de protection animale, la prise en compte réelle de la souffrance animale et des sanctions effectives, proportionnées et dissuasives envers les maltraitants, accompagnées d’une obligation de soins.</p>
      <p><span class="highlight">Porter secours aux animaux en souffrance :</span> Nous menons des enquêtes pour mauvais traitements et déposons plainte lorsque cela est nécessaire pour protéger les victimes.</p>
      <p><span class="highlight">Soigner, accompagner et reconstruire :</span> La majorité de nos protégés sont recueillis dans un état sanitaire et psychologique très dégradé. Nous collaborons avec des vétérinaires, éducateurs canins et comportementalistes afin d’offrir des soins adaptés à chaque animal.</p>
    </section>

    <section>
      <h3>Notre engagement au quotidien</h3>
      <p>Nous prenons en charge l’ensemble des frais vétérinaires, éducatifs et alimentaires jusqu’à l’adoption définitive, souvent plusieurs mois après le sauvetage.</p>
      <p>Tous nos protégés sont stérilisés, identifiés, vaccinés et vermifugés. Nous recherchons des familles d’accueil-relais pour leur rétablissement, puis des familles adoptantes capables de leur offrir une vie stable et aimante. Nous assurons également les prés-visites et post-visites pour garantir leur bien-être.</p>
    </section>

    <section>
      <h3>Une vision pour l’avenir</h3>
      <p class="quote">« Lorsque l’animal ne sera plus assimilé dans les esprits à un simple objet, lorsque l’animal sera préservé pour son existence-même et non pas pour les profits que l’on en tire, alors les droits de l’animal seront une conquête éthique et juridique et leur reconnaissance concrétisera un véritable progrès moral de l’homme. »<br>— Jean-Marie Coulon & Jean-Claude Nouët</p>
    </section>

    <section class="social">
      <h3>Rejoignez-nous sur les réseaux</h3>
      <p>
        <a href="#">Facebook</a> - <a href="#">Instagram</a>
      </p>
    </section>
  </div>
</template>

<style scoped>
.container {
  max-width: 1200px;
  margin: 50px auto;
  padding: 20px 30px;
  border-radius: 10px;
  color: #000;
  font-family: 'Arial', sans-serif;
  line-height: 1.7;
}



h3 {
  color: #286ecc;
  font-size: 1.5rem;
  margin-top: 25px;
  margin-bottom: 10px;
}

p {
  margin-bottom: 15px;
  font-size: 1rem;
  text-align: justify;
}

.highlight {
  color: #286ecc;
  font-weight: bold;
}

.quote {
  font-style: italic;
  border-left: 4px solid #286ecc;
  padding-left: 15px;
  margin: 20px 0;
  color: #333;
  background-color: #f0f8ff;
  border-radius: 5px;
}

.social {
  text-align: center;
  margin-top: 30px;
}

.social a {
  display: inline-block;
  margin: 0 10px;
  text-decoration: none;
  color: #286ecc;
  font-weight: bold;
  transition: color 0.3s;
}

.social a:hover {
  color: #1f4fa0;
}

@media (max-width: 600px) {
  .container {
    padding: 15px 20px;
  }
  h2 {
    font-size: 1.6rem;
  }
  h3 {
    font-size: 1.3rem;
  }
}
</style>
